import magnifiAPIInstance from "./apiInstance";

export const serverAPIs = {
  getServerDetails: ({ payload }) => magnifiAPIInstance.post("/get-server", payload),
  createServer: ({ payload }) => magnifiAPIInstance.post("/create_server", payload),
  deleteServer: ({ payload }) => magnifiAPIInstance.delete(`/delete-server/${payload.serverId}`, payload),
};
